export default "/images/900d8c11350cc1844aafc5c5ced795ad.avif";